
import authReducer  from './Api/authSlice.jsx';
import OrderReducer from './Global/OrderSlice.jsx';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import {Routes, Route  } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './Pages/Home/Home.jsx'

function App() {

  const store = configureStore({
    reducer: {
      auth: authReducer,
      orderStorage: OrderReducer,
    },
  });

  return (
     <>
       {<Provider store={store}>     
        <Routes >
          <Route path="/"  element = {<Home />}/>
        </Routes> 
      </Provider> }
     </>        
  );
}

export default App;
